import { useEffect, useState } from 'react'

function getOnLineStatus() {
  if (!navigator) return false
  if (typeof navigator.onLine === 'boolean') return navigator.onLine
  return true
}

export function useOnline() {
  const [status, setStatus] = useState(getOnLineStatus())

  const setOnline = () => setStatus(true)
  const setOffline = () => setStatus(false)

  useEffect(() => {
    window.addEventListener('online', setOnline)
    window.addEventListener('offline', setOffline)

    return () => {
      window.removeEventListener('online', setOnline)
      window.removeEventListener('offline', setOffline)
    }
  }, [])

  return status
}
